export enum TenantsListEnum {
    CUCUMBER = 'cucumber',
    COMVITA = 'comvita',
    BIOCANVAS = 'biocanvas'
}
